import React, { useContext, useEffect, useState } from 'react';
import styles from './MfAuthorization.module.css';
import AuthenticationContext from 'config/context/authenticationContext';
import { useMfImport } from 'features/compositions/context/MfImportContext';
import ActionLoader from 'components/shared/status/ActionLoader';
import ModalInputField from 'components/shared/modal/ModalInputField';
import { ArrowRightIcon } from 'assets/icons';
import GuiContext from 'config/context/guiContext';
import PluginsContext from 'config/context/pluginsContext';
import { testPrivateKey } from 'utils/validations';
import useTheme from 'config/useTheme';
import { useDatabaseAccess } from 'features/permissions/services/useDatabaseAccess';

const MfAuthorization = () => {
  const { dark } = useTheme();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pk, setPk] = useState('');
  const { setStep, setPkey } = useMfImport();
  const { isPermissionValid } = useContext(AuthenticationContext);
  const { getActiveByAccountName } = useContext(PluginsContext);

  const [validField, setValidField] = useState({
    pk: true
  })

  const { 
    userData: { guiname },
    selected: { selectedAccount, selectedServer },
    URL,
  } = useContext(GuiContext);
  const [proveravam, setProveravam] = useState(false);

  // GDE PODATAK SLECE. Ovlascenje nadzivi i brisanje baze i novi uvoz: kljuc na
  // `active` koji nije vlasnikov ostaje na nalogu, pa novouvezenu bazu takav
  // moze da cita i menja od prvog trenutka. To se nigde nije videlo — a jedini
  // trenutak kad je vazno je bas ovaj, pre isporuke.
  //
  // Obavestenje, ne brana. Po odluci od 01.09. kljuc je kljuc; ne uvodi se treci
  // nivo prava. Ali covek koji uvozi mora da zna gde uvozi.
  const { access: pristup } = useDatabaseAccess(selectedAccount);
  const tudjihKljuceva = pristup?.shared_keys || 0;

  const isActivePlugin = getActiveByAccountName(guiname)?.active?.includes(7);

  useEffect(() => {
    const checkPermission = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));

      if (isActivePlugin) {
        const valid = isPermissionValid("active");

        if (valid) {
          setStep(4);
        }
      }

      setLoading(false);
    };

    checkPermission();
    // `isActivePlugin` je obična logička vrednost, a druga dva su postojana
    // (`useCallback` u kontekstima), pa se provera ponovi samo ako se plugin
    // u međuvremenu uključi ili isključi — što je i ispravno.
  }, [isActivePlugin, isPermissionValid, setStep]);

  const goToTransmission = async () => {
    const isPkValid = testPrivateKey(pk);
    if (!isPkValid) {
      setError('Invalid private key!');
    }
    setValidField({
      pk: isPkValid
    });

    if (!isPkValid) { return; };

    // Pripada li ključ nalogu — ovde, a ne posle strukture i deploy-a. Do
    // 09.10.2026. tuđ ključ je prolazio do samog upisa i tek tada pao porukom
    // lanca iz koje se to nije videlo. Kad server ne može da presudi (čvor,
    // višestruko ovlašćenje), ide se dalje i presuđuje lanac.
    setProveravam(true);
    try {
      const res = await fetch(`${URL}/api/imports/key-check`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          server_url: selectedServer, database: selectedAccount,
          permission: 'active', private_key: pk,
        }),
      });
      const odgovor = await res.json();
      if (odgovor?.fits === false) {
        setError(odgovor.message);
        setValidField({ pk: false });
        return;
      }
    } catch {
      // Provera je pomoć, ne uslov — bez nje ostaje stari tok.
    } finally {
      setProveravam(false);
    }

    setError('');
    setPkey(pk);
    setStep(4);
  }

  if (loading) {
    return <div className={styles.mf_authorization}> <ActionLoader text="Authorization checking..." /></div>
  }

  return (
    <div className={`${styles.mf_authorization} ${dark ? styles.dark : ''}`}>
      <div className={styles.mf_authorization_data}>
        <p>
          {!isActivePlugin ? (
            <span>HOT KEY plugin is not active.</span>
          ) : (
            <span>HOT KEY is active, but no valid key is set.</span>
          )}
          <br />
          Enter your private key with "active" permission to authorize blockchain data transfer. Make sure you are in a secure and trusted environment.
        </p>

        <div className={styles.mf_insert_pk}>
          <ModalInputField
            privateKey
            placeholder="Private key"
            value={pk}
            setValue={(val) => setPk(val)}
            valid={validField.pk}
          />
        </div>
        {tudjihKljuceva > 0 && (
          <p className={styles.foreign_keys}>
            <b>
              {tudjihKljuceva} key{tudjihKljuceva === 1 ? "" : "s"} that
              {tudjihKljuceva === 1 ? " is" : " are"} not yours can already write
              to {selectedAccount}.
            </b>{" "}
            Whatever you import here, {tudjihKljuceva === 1 ? "its holder" : "their holders"}{" "}
            can read and change from the first moment. A key stays on the account
            through deleting and importing again — only its owner key can take it
            off, under Share Access → Take access away.
          </p>
        )}
        {error && <span className={styles.error_message}>{error}</span>}
        <button disabled={!pk || proveravam} onClick={() => goToTransmission()} className={styles.submit_btn}>
          {proveravam ? 'Checking the key…' : <>Go to data transmission <ArrowRightIcon /></>}
        </button>
      </div>
    </div>
  );
};

export default MfAuthorization;
